import _ from "lodash";
import { map, mergeMap } from "rxjs";
import { ofType } from "redux-observable";
import { findClosestPoints } from "../helperFunctions";

// types
const ADD_KEYPHRASE = "ADD_KEYPHRASE";
const ADD_KEYPHRASES = "ADD_KEYPHRASES";
const REMOVE_KEYPHRASE = "REMOVE_KEYPHRASE";
const SET_CONNECTORS = "SET_CONNECTORS";
const SET_GROUP = "SET_GROUP";

// actions
export const addKeyphrase = (keyphrase, position, group, groupName, text) => ({
  type: ADD_KEYPHRASE,
  payload: { keyphrase: keyphrase, position: position, group: group, groupName: groupName, text: text }
});
export const addKeyphrases = (keyphrases, positions, group, groupName, text) => ({
  type: ADD_KEYPHRASES,
  payload: { keyphrases: keyphrases, positions: positions, group: group, groupName: groupName, text: text }
});
export const removeKeyphrase = (keyphrase, groups, text) => ({
  type: REMOVE_KEYPHRASE,
  payload: { keyphrase: keyphrase, groups: groups, text: text }
});
export const setConnectors = (connectors, groupName, text) => ({
  type: SET_CONNECTORS,
  payload: { connectors: connectors, groupName: groupName, text: text }
});
export const setGroup = (group, groupName, text) => ({
  type: SET_GROUP,
  payload: { group: group, groupName: groupName, text: text }
});

// epics
export const addKeyphraseEpic = (action$) =>
  action$.pipe(
    ofType(ADD_KEYPHRASE),
    mergeMap((action) => [
      {
        group: _.union(action.payload.group, [{ name: action.payload.keyphrase, position: action.payload.position }]),
        groupName: action.payload.groupName,
        text: action.payload.text
      }
    ]),
    map((data) => setGroup(data.group, data.groupName, data.text))
  );

export const addKeyphrasesEpic = (action$) =>
  action$.pipe(
    ofType(ADD_KEYPHRASES),
    mergeMap((action) => [
      {
        group: _.union(
          action.payload.group,
          _.map(action.payload.keyphrases, (keyphrase, index) => ({
            name: keyphrase,
            position: action.payload.positions[index]
          }))
        ),
        groupName: action.payload.groupName,
        text: action.payload.text
      }
    ]),
    map((data) => setGroup(data.group, data.groupName, data.text))
  );

export const removeKeyphraseEpic = (action$) =>
  action$.pipe(
    ofType(REMOVE_KEYPHRASE),
    mergeMap((action) =>
      _.map(action.payload.groups[action.payload.text], (group, key) => ({
        group: _.reject(group, (entry) => entry.name === action.payload.keyphrase),
        groupName: key,
        text: action.payload.text
      }))
    ),
    map((data) => setGroup(data.group, data.groupName, data.text))
  );

export const connectorEpic = (action$) =>
  action$.pipe(
    ofType(SET_GROUP),
    mergeMap((action) => {
      const connectors = [];
      const connected = {};
      let nextNode = action.payload.group[0];
      for (let i = 0, j = _.size(action.payload.group) - 1; i < j; i++) {
        const possibleNodes = _.reject(action.payload.group, (node) => connected[node.name] === true);
        const closest = findClosestPoints(
          nextNode.position,
          _.map(possibleNodes, (node) => node.position),
          _.map(possibleNodes, (node) => node.name),
          1
        )[0];
        const closestNode =
          action.payload.group?.[_.findIndex(action.payload.group, (node) => node.name === closest.tag)];
        connectors.push({ start: nextNode.position, end: closestNode.position });
        connected[nextNode.name] = true;
        nextNode = closestNode;
      }
      return [
        {
          connectors: connectors,
          groupName: action.payload.groupName,
          text: action.payload.text
        }
      ];
    }),
    map((data) => setConnectors(data.connectors, data.groupName, data.text))
  );

// reducer
export const groupReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_GROUP:
      if (state[action.payload.text] === undefined) {
        state[action.payload.text] = {};
      }
      state[action.payload.text][action.payload.groupName] = action.payload.group;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};

export const connectorReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_CONNECTORS:
      if (state[action.payload.text] === undefined) {
        state[action.payload.text] = {};
      }
      state[action.payload.text][action.payload.groupName] = action.payload.connectors;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};
